import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import highlightVideo from "../../assets/Videos/new-vid.mp4"; // Make sure this path is correct

const Highlights = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="py-20" style={{ backgroundColor: "#F1F0EA" }}>
      <div
        className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center gap-12"
        style={{ placeContent: "center" }}
      >
        {/* Video Section */}
        <div
          className="md:w-3/6 flex justify-center items-center"
          data-aos="fade-right"
        >
          <video
            src={highlightVideo}
            autoPlay
            muted
            loop
            playsInline
            className="rounded-lg shadow-xl w-full h-auto max-w-[2000px]"
            style={{ height: "auto", width: "200%" }} // Adjust as needed
          />
        </div>

        {/* Timeline Content */}
        {/* Add your content here */}
      </div>
    </section>
  );
};

export default Highlights;
